import * as React from 'react';
import PropTypes from 'prop-types';

/**
 * SlideSubTitle
 */

const SlideSubTitle = ({ subTitle, tag, color = 'gold' }) => {
  const Tag = tag || 'h4';
  const colorClass = `text-${color}`;
  return <Tag className={`slide-subtitle h4 ${colorClass}`}>{subTitle}</Tag>;
};

SlideSubTitle.propTypes = {
  subTitle: PropTypes.string.isRequired,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  color: PropTypes.string,
};

export default SlideSubTitle;
